import React from "react";

import { PageHeader } from "src/layout/PageHeader";
import { SubHeader } from "src/layout/SubHeader";

type FeatureHeaderProps = {
  subHeaderRightContent?: React.ReactNode;
  showSubHeader?: boolean;
  breadcrumbs: { key: string; breadcrumb: React.ReactNode }[];
  sideContent?: React.ReactNode;
};

export const FeatureQueryHeader: React.FC<FeatureHeaderProps> = ({
  subHeaderRightContent,
  showSubHeader = true,
  breadcrumbs,
  sideContent,
}) => {
  return (
    <>
      <PageHeader
        {...(breadcrumbs.length > 0 ? { breadcrumbs } : { title: "" })}
        sideContent={sideContent}
      />
      {showSubHeader && (
        <SubHeader
          leftSlot={
            <span className="font-inter-semibold-14px text-gray-800">
              Features
            </span>
          }
        >
          {subHeaderRightContent ?? null}
        </SubHeader>
      )}
    </>
  );
};
